module.exports = __webpack_public_path__ + "static/US2_1P_traditional_v2-0923947618a708a7da989f69e74a40c3.png";